import React, { PureComponent } from 'react'
import { Jumbotron } from 'reactstrap'

class NotFound extends PureComponent {
    render() {
        return (
            <div className="container">
                <Jumbotron>
                    <h1>Recurso não encontrado</h1>
                    <p>A URL {this.props.location.pathname} não foi encontrada no sistema.</p>
                </Jumbotron>

            </div>
        )
    }
}

export default NotFound